<form [formGroup]="formGroup">
    <kendo-formfield>
        <p translate>
            dialouge.url.description
        </p>
        <div class="d-flex">
            <kendo-label [for]="url" text="{{ 'dialogue.url' | translate }}"></kendo-label>
        </div>
        <kendo-textbox #url
        placeholder="https://www.stiftung.de"
        formControlName="url"
        showSuccessIcon="initial"
        showErrorIcon="initial"
        preventEmptyFormatter
        [maxlength]=100
         ></kendo-textbox>
    </kendo-formfield>
</form>
<kendo-dialog-actions>
    <button kendoButton class="cancel-button" (click)="onCancelClick()" translate>
        <i></i>&nbsp;
        conformationDialog.cancel
    </button>
    <button kendoButton class="confirm-button" (click)="onSubmitClick()" translate [disabled]="!isUrlValid">
        <i></i>&nbsp;
        conformationDialog.confirm
    </button>
</kendo-dialog-actions>